import React, { useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';

interface WorkflowModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  isLoading: boolean;
  success?: boolean;
  message?: string;
}

export const WorkflowModal: React.FC<WorkflowModalProps> = ({
  show,
  onHide,
  title,
  isLoading,
  success,
  message
}) => {
  // While it animates closed the modal keeps what it showed last: the pages clear their state as they hide it,
  // and a cleared state reads as an error without text.
  const shown = useRef({ title, isLoading, success, message });
  if (show) {
    shown.current = { title, isLoading, success, message };
  }
  const view = shown.current;

  return (
    <Modal show={show} onHide={onHide} size="sm" centered className="modal-blur" backdrop="static">
      <Modal.Body>
        <button type="button" className="btn-close" onClick={onHide} aria-label="Close"></button>
        {view.isLoading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Spracováva sa...</span>
            </div>
            <h3>{view.title}</h3>
          </div>
        ) : (
          <>
            <div className={`modal-status bg-${view.success ? 'success' : 'danger'}`}></div>
            <div className="text-center py-4">
              {view.success ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon mb-2 text-success icon-lg">
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                  <path d="M9 12l2 2l4 -4"></path>
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon mb-2 text-danger icon-lg">
                  <path d="M12 9v4"></path>
                  <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z"></path>
                  <path d="M12 16h.01"></path>
                </svg>
              )}
              <h3>{view.success ? 'Úspešne dokončené' : 'Chyba'}</h3>
              {view.message && (
                <div className="text-secondary mt-2" style={{ whiteSpace: 'pre-line' }}>
                  {view.message}
                </div>
              )}
            </div>
          </>
        )}
      </Modal.Body>
      {!view.isLoading && (
        <Modal.Footer>
          <div className="w-100">
            <Button variant={view.success === false ? 'danger' : 'primary'} className="btn-pill w-100" onClick={onHide}>
              Zavrieť
            </Button>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};
